var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.334C0 9.28829 8.95431 0.333984 20 0.333984C31.0457 0.333984 40 9.28829 40 20.334C40 31.3797 31.0457 40.334 20 40.334C8.95431 40.334 0 31.3797 0 20.334Z",
    fill: "#5604F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.97 14.0357L20.72 9.52162C20.4996 9.39983 20.2518 9.33594 20 9.33594C19.7482 9.33594 19.5004 9.39983 19.28 9.52162L11.03 14.0376C10.7944 14.1665 10.5977 14.3563 10.4605 14.5871C10.3233 14.818 10.2506 15.0815 10.25 15.3501V24.3163C10.2506 24.5849 10.3233 24.8484 10.4605 25.0792C10.5977 25.3101 10.7944 25.4999 11.03 25.6288L19.28 30.1447C19.5004 30.2665 19.7482 30.3304 20 30.3304C20.2518 30.3304 20.4996 30.2665 20.72 30.1447L28.97 25.6288C29.2056 25.4999 29.4023 25.3101 29.5395 25.0792C29.6767 24.8484 29.7494 24.5849 29.75 24.3163V15.351C29.7499 15.082 29.6774 14.8179 29.5402 14.5865C29.403 14.3551 29.206 14.1648 28.97 14.0357ZM20 10.8341L27.5328 14.9591L24.7409 16.4863L17.2081 12.3613L20 10.8341ZM20 19.0841L12.4672 14.9591L15.6462 13.2182L23.1791 17.3432L20 19.0841ZM28.25 24.3201L20.75 28.4254V20.3807L23.75 18.7391V22.0841C23.75 22.283 23.829 22.4738 23.9697 22.6145C24.1103 22.7551 24.3011 22.8341 24.5 22.8341C24.6989 22.8341 24.8897 22.7551 25.0303 22.6145C25.171 22.4738 25.25 22.283 25.25 22.0841V17.9179L28.25 16.2763V24.3163V24.3201Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderConfirm);
export default __webpack_public_path__ + "static/media/OrderConfirm.bc89df3710d600a55df511439c422fe4.svg";
export { ForwardRef as ReactComponent };